import styled, { css } from 'styled-components';
const MIN_HEIGHT_LOGIN_IFRAME = 381;
/**
 * LoginIframe
 */
export const loginIframeStyles = () => css `
	border: none;
	width: 100%;
	height: ${(props) => props.height};
	min-height: ${MIN_HEIGHT_LOGIN_IFRAME};
`;
export const LoginIframe = styled.iframe `
	${loginIframeStyles}
`;
